import { ComponentType } from "react";
import { ActionFunction, LoaderFunction } from "react-router-dom";

import BillingDetailsTab from "v2/pages/billing/tabs/BillingDetailsTab";
import ManagePlanTab from "v2/pages/billing/tabs/ManagePlanTab";
import SubscriptionTab from "v2/pages/billing/tabs/SubscriptionTab";


export const BillingTabsRoutes: {
  [key: string]: {
    title: string,
    id?: string,
    Component: ComponentType,
    loader?: LoaderFunction,
    action?: ActionFunction
  }
} = {
  subscription: {
    title: "Subscription",
    Component: SubscriptionTab
  },
  details: {
    title: "Billing Details",
    Component: BillingDetailsTab
  },
  manage: {
    title: "Manage Plan",
    Component: ManagePlanTab
  },
};
